<template>
  <div class="h-full">
    <el-card class="h-full">
      <!-- input输入框部分 -->
      <div class="mb-20px flex items-center">
        <el-popover
          width="260"
          placement="bottom"
          trigger="hover"
          content="请谨慎变更区域操作，变更区域参数会导致人员位置显示，请在工作人员配合下进行操作。"
        >
          <i
            slot="reference"
            class="iconfont icon-bg-circleWarning text-rose-600 text-22px mr-10px cursor-pointer"
          ></i>
        </el-popover>
        <el-input
          v-model="areaName"
          class="mr-10px w-200px"
          placeholder="搜索区域名称"
          clearable
        ></el-input>
        <el-select
          v-model="sceneId"
          class="mr-10px w-200px"
          placeholder="请选择场景"
          filterable
          clearable
        >
          <el-option
            v-for="item in sceneList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
        <!-- button按钮部分 -->
        <el-button type="primary" @click="searchAreaList" :disabled="!$hasAccess('check')"
          >搜索</el-button
        >
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="operate('create')" :disabled="!$hasAccess('create')"
          >新增</el-button
        >
      </div>
      <!-- 列表 -->
      <div class="h-[calc(100%-105px)]">
        <el-table
          :data="tableData"
          v-loading="areaLoading"
          row-key="id"
          border
          height="100%"
          stripe
        >
          <el-table-column type="index" label="序号" width="70"></el-table-column>
          <el-table-column
            prop="sceneName"
            label="所属场景"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="name" label="区域名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="code" label="区域编码" show-overflow-tooltip></el-table-column>
          <el-table-column prop="x" label="X0" show-overflow-tooltip></el-table-column>
          <el-table-column prop="y" label="Y0" show-overflow-tooltip></el-table-column>
          <el-table-column prop="height" label="区域高度" show-overflow-tooltip></el-table-column>
          <el-table-column prop="angle" label="偏移角度" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" min-width="150px">
            <template slot-scope="{ row }">
              <el-button @click="operate('check', row)" size="mini" :disabled="!$hasAccess('check')"
                >查看</el-button
              >
              <el-button
                @click="operate('update', row)"
                size="mini"
                :disabled="!$hasAccess('update')"
                >编辑</el-button
              >
              <el-button @click="deleteArea(row)" size="mini" :disabled="!$hasAccess('delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-20px flex justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="getAreaList"
          :current-page.sync="page.pageNo"
          :page-sizes="pageSizeAll"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>
    <operateArea
      v-if="operateVisible"
      :visible.sync="operateVisible"
      :sceneList="sceneList"
      :operateType="operateType"
      :operateProps="operateProps"
      @refresh="getAreaList"
    ></operateArea>
  </div>
</template>

<script>
import { ImplementAreaApi } from '@wiz-api/personnel-position'
import { ModelSceneApi } from '@wiz-api/scene-management'
import { isNil } from 'lodash'

const implementAreaApi = new ImplementAreaApi()
const modelSceneApi = new ModelSceneApi()
const operateArea = () => {
  return import('./components/operateArea')
}
export default {
  components: {
    operateArea,
  },
  data() {
    return {
      sceneList: [],
      areaName: '',
      sceneId: '',
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      areaLoading: false,
      selectAreas: [],
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      operateVisible: false,
      operateType: 'create',
      operateProps: null,
    }
  },
  async created() {
    await this.getAreaList()
    await this.getSceneList()
  },
  methods: {
    // 获取区域列表
    async getAreaList() {
      this.areaLoading = true
      const [err, res] = await implementAreaApi.getList({
        filter: this.areaName,
        sceneId: this.sceneId,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && res) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
      this.areaLoading = false
    },
    // 获取场景列表
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isNil(res)) {
        this.sceneList = res.items
      }
    },
    // 搜索
    searchAreaList() {
      this.page.pageNo = 1
      this.getAreaList()
    },
    // 重置表单数据
    reset() {
      this.areaName = ''
      this.sceneId = ''
      this.searchAreaList()
    },
    // 操作
    operate(type, row) {
      this.operateType = type
      if (type !== 'create') {
        this.operateProps = row
      } else {
        this.operateProps = {}
      }
      this.operateVisible = true
    },
    // 删除区域
    deleteArea(row) {
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await implementAreaApi.callDelete(row.id)
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getAreaList()
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.getAreaList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
